import codes from './codes';

const { eur, gbp, pln, nok, sek, nzd, dkk } = codes;

export default {
  gb: gbp,
  fr: eur,
  es: eur,
  fi: eur,
  ie: Object.assign({}, eur, {
    decimalSign: '.',
    format: {
      pos: '%s %v',
      neg: '-%s %v',
      zero: '%s %v',
    },
  }),
  it: eur,
  no: nok,
  nz: nzd,
  pl: pln,
  se: sek,
  dk: dkk,
};
